import React, { useState } from 'react';

import Show from 'components/Show';
import Action from 'components/Misc/Action';
import { Title } from 'components/Misc/Typography';
import { Container } from 'components/Misc/Sortable';

import Blanks from 'containers/Administrator/Users/Create/Student/Blanks';
import Add from 'containers/Administrator/Users/Create/Student/Courses/Add';
import Course from 'containers/Administrator/Users/Create/Student/Courses/Course';

import { useUserCreateStore } from 'store/user/useUserCreateStore';

const Courses = ({ gradeId }) => {
	// Use user's creation store
	const onSortStudentCourse = useUserCreateStore(state => state.onSortStudentCourse);
	const courses = useUserCreateStore(state => {
		const grade = state.user.grades?.find(grade => grade.id === +gradeId);
		return grade?.courses;
	});

	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	// Handle course sort for student
	const onSort = (positions) => onSortStudentCourse(gradeId, positions);

	return (
		<div className="space-y-4">
			<Title title="Moduļi" />
			
			{/* Student's grade courses */}
			<Show if={courses?.length}>
				<Container
					lockAxis="y"
					lockOffset="0%"
					useDragHandle
					lockToContainerEdges
					onSortEnd={onSort}
					className="flex flex-col pr-2 space-y-2 max-h-96 overflow-y-auto"
				>
					{/* <div className="flex flex-col pr-2 space-y-2 max-h-96 overflow-y-auto"> */}
					{courses?.map((course, idx) =>
						<Course idx={idx} key={course.id} gradeId={gradeId} course={course} />
					)}
					{/* </div> */}
				</Container>
			</Show>

			{/* Blank selection modal */}
			<Blanks visible={!courses?.length} gradeId={gradeId} />

			{/* Student's blank modal toggle */}
			<Action
				icon="book"
				title="Pievienot moduli"
				subtitle="Piesaistiet moduļus atlasot tos pēc mācību kursa"
				onClick={handleModal}
			/>

			{/* Course selection modal */}
			<Add gradeId={gradeId} modal={modal} handleModal={handleModal} />
		</div>
	);
};

export default Courses;